import { AuthenticatedSession } from '@/authenticatedSession/authenticatedSession';
import { isYearMonthDay, ymdToString } from '@/database/yearMonthDayUtil';
import { ExpenseEntryData, ExpenseEntryEvent } from '@shared/types';

export const auditingEventForExpenseEntryField = (props: {
  field: keyof ExpenseEntryData;
  previousValue: ExpenseEntryData[keyof ExpenseEntryData];
  value: ExpenseEntryData[keyof ExpenseEntryData];
  authSession: AuthenticatedSession | undefined;
}): ExpenseEntryEvent => {
  const { field, previousValue, value, authSession } = props;

  const valueAsString = (v: unknown) => {
    if (v === undefined || v === null) return 'none';
    if (typeof v === 'string') return v.trim() === '' ? 'none' : v;
    if (typeof v === 'number') return String(v);
    if (isYearMonthDay(v)) return ymdToString({ ymd: v, format: 'MM/dd/yyyy' });
    return String(v);
  };

  return {
    type: 'modified',
    timestamp: new Date(),
    userId: authSession?.userIds.firestore || '',
    details: `${field} changed from ${valueAsString(previousValue)} to ${valueAsString(value)}`,
  };
};
